/**
 * PhaseProgressCell — Célula de "Fase" com barra de progresso.
 *
 * Reusada na listagem de Negócios e na listagem de Atividades para
 * manter exatamente o mesmo leiaute (DealPhaseProgress) entre páginas.
 *
 * @version 1.0.0 (2026-05-10) — Extraído de CrmDeals.tsx para reuso.
 */
import React from 'react';
import { DealPhaseProgress } from '@/components/crm/deals/DealPhaseProgress';
import { usePipelinePhaseStats } from '@/hooks/usePipelinePhaseStats';

interface PhaseProgressCellProps {
  /** ID do pipeline (necessário para descobrir o total de fases). */
  pipelineId: string;
  /** Nome da fase atual (exibido como tooltip/legenda). */
  phaseName: string;
  /** Cor (hex/hsl) da fase, vinda do banco. */
  phaseColor: string | null;
  /** Posição da fase no pipeline (1-indexed). */
  phaseSortOrder: number;
}

/**
 * Componente auxiliar para exibir progresso da fase no pipeline.
 * Busca o total de fases do pipeline para calcular o avanço.
 */
export function PhaseProgressCell({
  pipelineId,
  phaseName,
  phaseColor,
  phaseSortOrder,
}: PhaseProgressCellProps) {
  const { phases } = usePipelinePhaseStats(pipelineId);
  const totalPhases = phases.length || 1;

  return (
    <DealPhaseProgress
      phaseName={phaseName || ''}
      phaseColor={phaseColor || null}
      phaseSortOrder={phaseSortOrder || 1}
      totalPhases={totalPhases}
    />
  );
}
